module.exports = __webpack_public_path__ + "img/2man-2.2392edd9.png";